<template>
    <b-overlay :show="loading" rounded="sm">
        <div v-if="canEdit">
            <b-card v-if="actual_organization">
                <b-form @submit="submit" @submit.stop.prevent>

                    <div class="row">
                        <div class="col-sm-4">
                            <!-- Field -->
                            <b-form-group
                                label="Código da Escola">
                                <b>
                                    {{ actual_organization.code }}
                                </b>
                            </b-form-group>
                        </div>
                        <div class="col-sm-8">
                            <!-- Field -->
                            <b-form-group
                                label="Administrador da Escola">

                                <b>
                                    {{ actual_organization.teacher_owner.name }}
                                </b>

                            </b-form-group>
                        </div>
                    </div>

                    <!-- Field -->
                    <b-form-group
                        label="Nome da Escola">
                        <!-- Input -->
                        <b-form-input
                            v-model="form.name"
                            :state="hasErrors('name', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="name" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Modos de Correção" description="Qual os modos de correção que você trabalha ? Caso não encontre, entre em contato com o suporte para adicionarmos">

                        <multiselect
                            v-model="form.modes"
                            :options="modes"
                            :taggable="true"
                            :multiple="true"
                            :loading="loading"
                            track-by="id"
                            label="name"
                            placeholder="Qual os modos de correção que sua escola usa ?"
                            tag-placeholder="Qual os modos de correção que sua escola usa ?"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">

                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há modos de correção para serem exibidos :(
                            </span>

                        </multiselect>

                        <!-- Error -->
                        <has-errors :errors="errors" name="modes" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Restrições de Envio">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.only_task"
                            name="only_task"
                            switch>

                            <span v-if="form.only_task">
                                Os alunos poderão enviar redações <b>somente através de atividades</b>, ficando vetado envios avulsos.
                            </span>

                            <span v-else>
                                Os alunos poderão enviar redações através das <b>atividades e também de forma avulsa</b> (escolhendo tema ou modo de correção).
                            </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="only_task" />
                    </b-form-group>

                    <b-alert :show="form.only_task" variant="info" class="mb-3">
                        Os menus de "temas" e o envio de redações avulsas serão bloqueados para que o aluno só utilize
                        o módulo de "atividades" para envio da sua redação. Quando o professor destinar uma atividade
                        para a turma em que o aluno faz parte, ele será notificado e poderá fazer o envio :)
                    </b-alert>

                    <!-- Field -->
                    <b-form-group
                        label="Anexar Material Complementar em Atividades"
                        description="Se você deseja enviar material complementar (pdf , planilha ou qualquer arquivo), você pode ativar essa opção para seus alunos.">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.task_documents"
                            name="task_documents"
                            switch>

                            <span v-if="form.task_documents">
                                Quero ativar o material complementar nas minhas atividades.
                            </span>

                            <span v-else>
                                Não quero ativar o material complementar nas minhas atividades.
                            </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="task_documents" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Modo de Comentário em Texto nas Redações">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.comment_full"
                            name="comment_full"
                            switch>

                            <span v-if="form.comment_full">
                                Quero trabalhar com <b>comentários longos e preciso de um editor com funções mais avançadas</b> (negrito, itálico, alinha, etc ...). Geralmente usado para professores que corrigem para concursos.
                            </span>

                            <span v-else>
                                Quero trabalhar com comentários gerais nos <b>textos de uma maneira mais simples</b>. Geralmente usado para professores que corrigem para Fundamental II ou que desejam um processo mais simplificado.
                            </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="comment_full" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Escolha do Corretor no Envio das Redações">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.force_teacher"
                            name="force_teacher"
                            switch>

                            <span v-if="form.force_teacher">
                                Quero <b>forçar os alunos a escolherem qual o seu corretor no momento do envio da redação</b>, com exceção das redações enviadas por atividade (em que o corretor é escolhido pelo criador da atividade).
                            </span>

                            <span v-else>
                                <b>Não quero que meus alunos escolham o corretor no momento do envio da redação</b>. Essa responsabilidade fica a cargo da escola/professores.
                            </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="force_teacher" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Restrição da Matricula do Aluno">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.one_student"
                            name="one_student"
                            switch>

                            <span v-if="form.one_student">
                                Quero permitir que meu aluno <b>só faça parte de uma turma</b>. Não permitir ele se matricular em outra quando já estiver vinculado a uma turma.
                            </span>

                            <span v-else>
                                Quero permitir que meu aluno <b>participe de uma ou mais turmas</b> na minha escola.
                            </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="one_student" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Modo Créditos de Redação">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.credit"
                            name="credit"
                            switch>

                            <span v-if="form.credit">
                                Quero permitir que meu aluno só envie redação se tiver créditos e tiverem dentro do prazo de validade
                            </span>

                            <span v-else>
                                Não quero limitar envio de redações dos meus alunos
                            </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="credit" />
                    </b-form-group>

                    <b-alert :show="form.credit" variant="info" class="mb-3">
                        Você pode configurar a qtd. de créditos e o prazo de validade no menu de alunos.
                    </b-alert>

                    <!-- Field -->
                    <b-form-group
                        v-if="form.credit"
                        label="Visualização de Créditos por Aluno">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.show_credits"
                            name="show_credits"
                            switch>

                            <span v-if="form.show_credits">
                                Quero que os alunos visualizem a quantidade de créditos na página inicial
                            </span>

                            <span v-else>
                                Não quero que meus alunos visualizem a quantidade de créditos (Exceto uma mensagem de alerta quando ele não possuir nenhum crédito)
                            </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="show_credits" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Tema Livre">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.force_mode_documents"
                            name="force_mode_documents"
                            switch>

                            <span v-if="form.force_mode_documents">
                                Quando o aluno selecionar um tema livre, <b>forçar ele enviar pelo menos 1 ou mais arquivos</b> de textos motivadores que deram base a escrita da sua redação.
                            </span>

                            <span v-else>
                                Quando o aluno selecionar um tema livre, <b>não obrigar ele enviar material de referência.</b>
                            </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="force_mode_documents" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Marcações na Redação"
                        description="Se você tiver problemas nas folhas de redação enviadas, ou a letra esteja muito pequena, você pode ativar a opção de zoom para facilitar seu trabalho">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.zoom"
                            name="zoom"
                            switch>

                            <span v-if="form.zoom">
                                Quero ativar o recurso de zoom nas redações.
                            </span>

                            <span v-else>
                                Não quero ativar o recurso de zoom nas redações
                            </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="zoom" />
                     
                    </b-form-group>

                    <b-form-group
                        description="Você poderá avaliar a redação sem atribuir uma nota e ocultar o campo da pontuação para o aluno e para a geração de relatórios.">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.no_note_essay"
                            name="no_note_essay"
                            switch>

                            <span v-if="form.no_note_essay">
                                Permitir avaliar sem nota a redação do aluno.
                            </span>

                            <span v-else>
                                Não quero permitir enviar redação sem nota para o aluno.
                            </span>

                       </b-form-checkbox>

                       <!-- Error -->
                     <has-errors :errors="errors" name="no_note_essay" />
                    </b-form-group>

                    <b-form-group
                        label="Professor Revisor"
                        description="Você poderá definir um professor para revisar a redação e somente ao finalizar a revisão então será possivel mudar o status para corrigida.">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.revisor_teacher"
                            name="revisor_teacher"
                            switch>

                            <span v-if="form.revisor_teacher">
                                Permitir adicionar professor revisor.
                            </span>

                            <span v-else>
                                Não quero poder adicionar professor revisor.
                            </span>

                       </b-form-checkbox>

                       <!-- Error -->
                     <has-errors :errors="errors" name="revisor_teacher" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Exibir Ranking no ambiente do aluno"
                        description="Se você deseja que os alunos possam ver e comparar sua posição no ranking da turma que faz parte.">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.show_student_ranking"
                            name="task_documents"
                            switch>

                            <span v-if="form.show_student_ranking">
                                Quero exibir ranking no ambiente do aluno.
                            </span>

                            <span v-else>
                                Não quero exibir o ranking no ambiente do aluno.
                            </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="show_student_ranking" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Link Externo na Turma"
                        description="Se deseja enviar algum link externo no painel inicial dos seus alunos, você pode ativar essa opção.">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.external_link_group"
                            name="external_link_group"
                            switch>

                            <span v-if="form.external_link_group">
                                Quero ativar o link externo na turma
                            </span>

                            <span v-else>
                                Não quero ativar o link externo na turma
                            </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="external_link_group" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Campo Extra de Matrícula em Alunos"
                        description="Se você trabalha com outro sistema que gera a matrícula do aluno, você pode ativar esse campo extra nessa configuração. Os alunos terão que inserir a matricula no momento do cadastro na plataforma.">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.matriculation"
                            name="zoom"
                            switch>

                            <span v-if="form.matriculation">
                                Quero ativar o campo extra de matrícula para os meus alunos
                            </span>

                            <span v-else>
                                Não quero ativar o campo extra de matrícula para os meus alunos
                            </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="matriculation" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Whatsapp no Painel do Aluno"
                        description="Se você possui um whatsapp para atendimento aos alunos, podemos disponibilizar um link para os alunos conseguirem mandar mensagem">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.wpp_enabled"
                            name="wpp_enabled"
                            switch>

                            <span v-if="form.wpp_enabled">
                                Quero ativar o número de whatsapp para os meus alunos entrarem em contato
                            </span>

                            <span v-else>
                                Não quero ativar o número de whatsapp para os meus alunos
                            </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="wpp_enabled" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        v-if="form.wpp_enabled"
                        label="Telefone do Whatsapp Atendimento aos Alunos">
                        <!-- Input -->
                        <the-mask
                            type="tel"
                            :mask="['(##) #####-####', '(##) ####-####']"
                            v-model="form.wpp_number"
                            class="form-control"
                            placeholder="DDD + Número"
                        ></the-mask>

                        <!-- Error -->
                        <has-errors :errors="errors" name="wpp_number" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Prazo de correção das redações (Em dias)">
                        <!-- Input -->
                        <b-form-input
                            type="number"
                            min="0"
                            v-model="form.days_essay_due"
                            :state="hasErrors('days_essay_due', errors)"
                        ></b-form-input>

                        <small class="text-muted">
                            Caso você queira um prazo máximo para correção das redações, insira o número de dias acima para você conseguir avaliar os corretores. Caso não queira esse recurso, basta deixar o campo em branco e salvar.
                        </small>

                        <!-- Error -->
                        <has-errors :errors="errors" name="days_essay_due" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Coluna Temas nas Listagem de Redações"
                        description="No menu de redações, alguns professores preferem que sejam listados as propostas/temas de cada redação previamente">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.show_theme_of_essay"
                            name="show_theme_of_essay"
                            switch>

                            <span v-if="form.show_theme_of_essay">
                                Quero ativar a coluna de tema na listagem geral de redações.
                            </span>

                            <span v-else>
                                Não quero ativar a coluna de tema na listagem geral de redações.
                            </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="show_theme_of_essay" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Status de Escrita do Aluno nos Temas"
                        description="Na área do aluno há um filtro para listar os temas não escritos e escritos. Você pode definir qual será o padrão inicial para os alunos.">

                        <!-- Select -->
                        <b-form-select
                            v-model="form.student_write_status"
                            :options="optionsWrites"
                            name="student_write_status"
                            :state="hasErrors('student_write_status', errors)"
                        >
                        </b-form-select>

                        <!-- Error -->
                        <has-errors :errors="errors" name="student_write_status" />
                    </b-form-group>

                    <!-- Submit -->
                    <b-button type="submit" variant="primary" :disable="loading">
                        Atualizar
                    </b-button>
                </b-form>
            </b-card>
        </div>
        <div v-else>
            <b-card v-if="actual_organization">

                <div class="row">
                    <div class="col-sm-4">
                        <!-- Field -->
                        <b-form-group
                            label="Código da Escola">

                            <b class="h3">
                                <i class="fas fa-code mr-1"></i> {{ actual_organization.code }}
                            </b>

                        </b-form-group>
                    </div>
                    <div class="col-sm-8">
                        <!-- Field -->
                        <b-form-group
                            label="Administrador da Escola">

                            <b>
                                <i class="fas fa-user-alt mr-1"></i> {{ actual_organization.teacher_owner.name }}
                            </b>

                        </b-form-group>
                    </div>
                </div>

                <div class="row">

                    <div class="col-sm-4">
                        <!-- Field -->
                        <b-form-group
                            label="Logo da Escola">

                            <div v-if="actual_organization.preview">
                                <img :src="actual_organization.preview" class="img-thumbnail" style="max-width: 100%"/>
                            </div>
                            <div class="text-muted" v-else>
                                Não há logotipo enviado .
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-sm-8">
                        <!-- Field -->
                        <b-form-group
                            label="Nome da Escola">

                            <b>
                                {{ actual_organization.name }}
                            </b>

                        </b-form-group>
                    </div>
                </div>
            </b-card>
        </div>
    </b-overlay>
</template>

<script>

export default {
    props: ['canEdit'],
    data() {
        return {
            loading: false,
            errors: {},
            form: {
                name: null,
                only_task: null,
                comment_full: null,
                force_teacher: null,
                one_student: null,
                credit: null,
                force_mode_documents: null,
                show_credits: null,
                modes: [],
                zoom: null,
                matriculation: null,
                wpp_enabled: null,
                wpp_number: null,
                show_theme_of_essay: null,
                telegram_by_group: null,
                task_documents: null,
                days_essay_due: null,
                student_write_status: null,
                no_note_essay: null,
                show_student_ranking: null,
                revisor_teacher: null,
            },
            actual_organization: null,
            modes: [],
            optionsWrites: [
                {
                    value: 'all',
                    text: 'Todos os temas independente do aluno ter escrito ou não'
                },
                {
                    value: 'wrote',
                    text: 'Apenas os temas que o aluno escreveu'
                },
                {
                    value: 'not_wrote',
                    text: 'Apenas os temas que o aluno não escreveu'
                }
            ]
        }
    },
    created() {
        this.load();
    },
    methods: {

        load() {
            this.loading = true;
            axios.get('/teacher/organization?complete=true')
                .then((result) => {
                    const response = result.data.data

                    this.actual_organization = response.actual_organization;
                    this.modes = response.modes;
                    this.form.name = response.actual_organization.name
                    this.form.modes = response.actual_organization.modes
                    this.form.only_task = response.actual_organization.only_task
                    this.form.comment_full = response.actual_organization.comment_full
                    this.form.force_teacher = response.actual_organization.force_teacher
                    this.form.one_student = response.actual_organization.one_student
                    this.form.credit = response.actual_organization.credit
                    this.form.force_mode_documents = response.actual_organization.force_mode_documents
                    this.form.show_credits = response.actual_organization.show_credits
                    this.form.zoom = response.actual_organization.zoom
                    this.form.matriculation = response.actual_organization.matriculation
                    this.form.wpp_enabled = response.actual_organization.wpp_enabled
                    this.form.wpp_number = response.actual_organization.wpp_number
                    this.form.show_theme_of_essay = response.actual_organization.show_theme_of_essay
                    this.form.telegram_by_group = response.actual_organization.telegram_by_group
                    this.form.task_documents = response.actual_organization.task_documents
                    this.form.days_essay_due = response.actual_organization.days_essay_due
                    this.form.student_write_status = response.actual_organization.student_write_status
                    this.form.no_note_essay = response.actual_organization.no_note_essay
                    this.form.show_student_ranking = response.actual_organization.show_student_ranking
                    this.form.revisor_teacher = response.actual_organization.revisor_teacher
                })
                .finally(() => this.loading = false)
        },

        submit() {
            this.loading = true;

            axios.put('/teacher/organization', {
                ...this.form,
                modes: this.form.modes.map(element => (element.id))
            })
                .then((result) => {
                    // Redirect
                    this.redirectIfNeed(result)

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },

    }
}
</script>

<style scoped>
    .cropper {
        background: #DDD;
    }
</style>
